import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

import { BufferingComponent } from '../../../ui/buffering/buffering.component';
import { BaseModalComponent } from '../../base-modal/base-modal.component';

@Component({
  selector: 'mb-download-prepare-modal',
  templateUrl: './download-prepare-modal.component.html',
  styleUrls: ['./download-prepare-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModalComponent, BufferingComponent, MatDialogClose, TranslatePipe],
})
export class DownloadPrepareModalComponent {
  @Input() text?: string;
  @Output() requestCancel = new EventEmitter();
}
